var _style, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconActionBarTags = function SvgIconActionBarTags(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 17.2 17.1",
    style: {
      enableBackground: "new 0 0 17.2 17.1"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#264D6D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.2,3.1V1.3c0-0.1,0-0.1,0-0.2c0-0.7-0.5-1.1-1.2-1.1c-1.3,0-2.6,0-3.9,0c-1.1,0-2.2,0-3.2,0l0,0 C8.6,0,8.2,0.1,8.1,0.3C7.8,0.6,7.4,1,7.2,1.3L4.8,3.7C3.4,5,2,6.4,0.8,7.7c-1,1-1,2.4,0,3.4s1.9,2,2.9,2.9 c0.8,0.8,1.6,1.6,2.4,2.4c0.4,0.4,0.8,0.6,1.2,0.7l0,0c0,0,0,0,0.1,0h0.8l0,0c0.4-0.2,0.9-0.4,1.3-0.8c2.1-2.1,4.4-4.4,7.2-7.2 c0.4-0.4,0.5-0.8,0.5-1.3C17.2,6.4,17.2,4.7,17.2,3.1z M15.8,7.4c0,0.4-0.1,0.7-0.4,1l0,0c-0.1,0.1-0.1,0.1-0.2,0.2 c-1.7,1.7-3.4,3.4-5.1,5.1L10,13.8L3.4,7.1L3.5,7c1.7-1.7,3.4-3.4,5.1-5.1c0.1-0.1,0.2-0.2,0.4-0.3c0.2-0.2,0.5-0.3,0.8-0.3 c1.3,0,2.6,0,4,0h1.6c0.1,0,0.2,0,0.3,0c0.2,0,0.3,0.1,0.3,0.3c0,0.1,0,0.1,0,0.2v1.5C15.8,4.7,15.8,6.1,15.8,7.4z M1.6,8.9 c0.1-0.2,0.3-0.4,0.5-0.6l0.1-0.1L8.9,15l-0.1,0.1c-0.2,0.2-0.4,0.4-0.6,0.6C7.9,16,7.4,16,7,15.7c-0.1-0.1-0.1-0.1-0.2-0.2 l-5.2-5.2c-0.1-0.1-0.1-0.1-0.2-0.2C1.3,9.7,1.3,9.2,1.6,8.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.1,2.8c-0.6,0-1.2,0.2-1.6,0.6c-0.4,0.4-0.7,1-0.7,1.6c0,1.3,1,2.3,2.3,2.3l0,0c0.6,0,1.2-0.2,1.6-0.7 c0.4-0.4,0.7-1,0.7-1.6C14.4,3.9,13.4,2.8,12.1,2.8z M12.1,5.8L12.1,5.8c-0.4,0-0.7-0.3-0.7-0.7c0-0.2,0.1-0.4,0.2-0.5 c0.1-0.1,0.3-0.2,0.5-0.2l0,0c0.4,0,0.7,0.3,0.7,0.7C12.8,5.5,12.4,5.8,12.1,5.8z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconActionBarTags, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-action-bar-tags.c0f5d2b3.svg";
export { ForwardRef as ReactComponent };